enum ActionTypeEnum {
    SET_APP_STATE,
    SET_INITIAL_INPUT_STATE,

    SET_MAIN_STATE,
    RESET_MAIN_STATE,

    CLICK_FIND_JOB_BTN,

    ADD_REMOVE_MUTATION,

    CHANGE_JOB_TITLE_FIELD,
    CHANGE_EMAIL_FIELD,
    CHANGE_TYPE_INPUT_DATA,
    CHANGE_MAX_NUM_SEQ_FIELD,
    CHANGE_BLAST_E_VAL_FIELD,
    CHANGE_MIN_IDENTITY_FIELD,
    CHANGE_MAX_IDENTITY_FIELD,
    CHANGE_PDB_ID_FIELD,
    CHANGE_UNIPROT_ID_FIELD,
    CHANGE_SEQUENCE_FIELD,
    CHANGE_PDB_CHAIN_FIELD,
    CHANGE_STRUCTURE_INFO,

    TEST_MESSAGE,

    SEQUENCE_FROM_ID,

    TOGGLE_MODELLING,

    SUBMIT_INPUT,
    JOB_CONFIGURATION,

    LOAD_INPUT_FILE,

    CHANGE_LOW_RISK_DESIGN,
    CHANGE_HIGH_RISK_DESIGN,
    CHANGE_ANCESTRAL_RISK_DESIGN,

    CHANGE_MAJORITY_CONSENSUS_MIN_IDENTITY,
    CHANGE_RATIO_CONSENSUS_MIN_FREQ,
    CHANGE_RATIO_CONSENSUS_MIN_RATIO,
    CHANGE_GLOBAL_CONSENSUS_GAP_THRESHOLD,

    TOGGLE_FORCE_FIELD_MUTATIONS,
    TOGGLE_B_FACTOR_ANALYSIS,
    TOGGLE_CONSENSUS_MUTATIONS,

    GROUP_AUTOMATED_SINGLE_POINT,
    GROUP_AUTOMATED_MULTIPLE_POINT,

    CHANGE_CALCULATION,
    LOAD_INDEXES,

    // summary
    SUMMARY_NEW_JOB_REQUEST,
    SUMMARY_NEW_JOB_FAILURE,
    SUMMARY_NEW_JOB_SUCCESS,

    // job
    JOB_INFO_REQUEST,
    JOB_INFO_NON_EXIST,
    JOB_INFO_FAILURE,
    JOB_INFO_SUCCESS,

    JOB_GET_INPUT_REQUEST,
    JOB_GET_INPUT_FAILURE,
    JOB_GET_INPUT_SUCCESS,

    JOB_RERUN_REQUEST,
    JOB_RERUN_FAILURE,
    JOB_RERUN_SUCCESS,

    // job results
    BTC_MUTATION_SUCCESS,
    LOW_RISK_MUTATION_SUCCESS,
    HIGH_RISK_MUTATION_SUCCESS,
    COMBINED_LOW_RISK_MUTATION_SUCCESS,
    COMBINED_HIGH_RISK_MUTATION_SUCCESS,
    ANCESTRAL_DESIGNS_SUCCESS,
    ALL_RESIDUES_MUTATION_SUCCESS,

    // advanced settings : threshold settings
    CHANGE_EVOLUTION_FOLD_X_THRESHOLD,
    CHANGE_ENERGY_FOLD_X_THRESHOLD,
    CHANGE_ENERGY_ROSETTA_THRESHOLD,
    CHANGE_MULTIPOINT_ROSETTA_THRESHOLD,

    // advanced settings : analysis of correlated positions
    CHANGE_Z_SCORE_THRESHOLD,
    SET_JOB_ID,
    REMOVE_MUTATIONS_ON_POSITION,
    ADD_ALL_MUTATIONS_ON_POSITION,
    ADD_CUSTOM_MUTANT_MUTATIONS,
    REMOVE_CUSTOM_MUTANT_MUTATIONS,
    SET_SITES_ANNOTATIONS,
    CHANGE_MM_SELECTION,
    SET_SELECTED_STRUCTURE_INFO,
    SET_SELECTED_SITE_ANOTATIONS,
    OBTAIN_CHAINS,
    SET_WAITING_PDB,
    SET_WAITING_CAT,
    SET_SEQUENCE_CHECKED,
    SET_JOB_FINISHED,
    SET_CALCULATION_TYPES,
    SET_SHOW_CHAINS_SELECTION,
    CLEAR_MUTATIONS,
    CHANGE_LIMIT_FORCE_FIELD,

    ADD_USER_RESIDUE,
    UPDATE_SITES_ANNOTATIONS,
    SET_CALCULATION_MAPPING,
    SET_RESULT_PDB,

}

export default ActionTypeEnum;
